import React from 'react'
import {subDays} from "date-fns";
import DateRangePicker from "react-date-range/dist/components/DateRangePicker";

const StatisticsDateRangePicker = ({startDate, endDate, onPeriodChanged}) => {

    // State for the date picker filter criteria
    const [dateRange, setDateRange] = React.useState([
        {
            startDate: startDate || subDays(new Date(), 7),
            endDate: endDate || new Date(),
            key: 'selection'
        }
    ])

    const handleChangeDateRange = (range) => {
        setDateRange([range.selection])

        // Streamlining of the start/end date because the DateRangePicker is inconsistent between manual and suggested selection (last week, current month, ...)
        const startDate = new Date([range.selection][0].startDate)
        const endDate = new Date([range.selection][0].endDate)

        startDate.setHours(0)
        startDate.setMinutes(0)
        startDate.setSeconds(0)
        startDate.setMilliseconds(0)

        endDate.setHours(23)
        endDate.setMinutes(59)
        endDate.setSeconds(59)
        endDate.setMilliseconds(999)

        onPeriodChanged(startDate, endDate)
    }

    return <DateRangePicker
        onChange={handleChangeDateRange}
        showSelectionPreview={true}
        moveRangeOnFirstSelection={false}
        months={1}
        ranges={dateRange}
        direction="horizontal"
    />

}

export default StatisticsDateRangePicker
